
import { defineComponent } from 'vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'glossary-definition-hint',
    components: { KnHint }
})
